module.exports = __webpack_public_path__ + "a27a1c247f213ef927ad801dd37c6aa9.png";